import store from "@/store/index";

export default {
  methods: {
    failNotification(message) {
      store.state.snackbar = {
        message: message || "Ha ocurrido un error en el servidor",
        show: true,
        color: "error",
      };
    },
    successNotification(message) {
      store.state.snackbar = {
        message: message || "Transacción exitosa",
        show: true,
        color: "success",
      };
    },
  },
};
